module.exports = __webpack_public_path__ + "img/dog-head.8e1c4f27.svg";